// gets overwritten
// Currently used only for sections/meatLocations-article.liquid
const swiper = new Swiper(".meatLocations-carousel-swiper", {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: false,
});
